import Vue from 'vue';

import './assets/styles/theme.scss';
import './assets/styles/app.scss';
import './assets/styles/print.scss';

import store from './store';
import router from './router';
import './directives';
import './filters';
import './plugins';

import App from './components/App';

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
    router,
    store,
    render: h => h(App),
    mq: {
        xs: '(min-width: 0)',
        sm: '(min-width: 576px)',
        md: '(min-width: 768px)',
        lg: '(min-width: 992px)',
        xl: '(min-width: 1200px)',
    },
}).$mount('#app');
